import {
  createColumnHelper,
  getCoreRowModel,
  getFacetedMinMaxValues,
  getFacetedRowModel,
  getFacetedUniqueValues,
  getFilteredRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  useReactTable,
} from '@tanstack/react-table';
import PaginatedTable from '../Common/PaginatedTable';
import { HiPencilAlt, HiXCircle } from 'react-icons/hi';
import { EquipmentVideo } from '../../Models/EquipmentVideo';

export default function EquipmentVideoListTable({
  data,
  deleteEquipmentVideo,
  editEquipmentVideo,
}: {
  data: EquipmentVideo[];
  deleteEquipmentVideo(id: number): void;
  editEquipmentVideo: (feature: EquipmentVideo) => void;
}) {
  const columnHelper = createColumnHelper<EquipmentVideo>();

  const columns = [
    columnHelper.accessor((row) => row.id, {
      id: 'id',
      header: '',
      cell: (info) => (
        <div className='flex justify-center gap-1'>
          <button
            type='button'
            className='buttonMain p-2'
            onClick={() => editEquipmentVideo(info.row.original)}
          >
            <HiPencilAlt />
          </button>
          <button
            type='button'
            className='buttonCancel p-2'
            onClick={() => deleteEquipmentVideo(info.getValue())}
          >
            <HiXCircle />
          </button>
        </div>
      ),
      footer: (info) => info.column.id,
      size: 35,
      enableColumnFilter: false,
    }),
    columnHelper.accessor((row) => row.safeVideoURL, {
      id: 'safeVideoURL',
      header: 'Video',
      cell: (info) => (
        <div className='flex justify-center gap-1'>
          <iframe
            width='560'
            height='315'
            src={`${info.row.original.safeVideoURL}`}
          ></iframe>
        </div>
      ),
      sortingFn: 'alphanumeric',
      filterFn: 'includesString',
    }),
    columnHelper.accessor((row) => row.caption, {
      id: 'caption',
      header: 'Caption',
      sortingFn: 'alphanumeric',
      filterFn: 'includesString',
    }),
  ];

  const table = useReactTable({
    data,
    columns,
    initialState: {
      pagination: {
        pageIndex: 0,
        pageSize: 20,
      },
    },
    getSortedRowModel: getSortedRowModel(),
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getFacetedRowModel: getFacetedRowModel(),
    getFacetedUniqueValues: getFacetedUniqueValues(),
    getFacetedMinMaxValues: getFacetedMinMaxValues(),
  });

  return (
    <>
      <div className='w-full mx-auto overflow-x-auto'>
        <PaginatedTable
          table={table}
          dataCount={data.length}
          columnResizeMode='onChange'
          showFilters={true}
        />
      </div>
    </>
  );
}
